// @flow
import { HelpSupportActionTypes } from './constants';

type AuthAction = { type: string, payload: {} | string };

export const createSupportActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.CREATE_SUPPORT_DATA_FIRST,
    data,
});

export const getSupportActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.SUPPORT_DATA_FIRST,
    data,
});

export const getSupportAdminActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.SUPPORT_ADMIN_DATA_FIRST,
    data,
});

export const updateSupportActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.UPDATE_SUPPORT_DATA_FIRST,
    data,
});

export const createChatActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.CREATE_CHAT_DATA_FIRST,
    data,
});

export const getChatActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.GET_CHAT_DATA_FIRST,
    data,
});

export const getTicketByIdActions = (data): AuthAction => ({
    type: HelpSupportActionTypes.GET_TICKET_BY_ID_FIRST,
    data,
});